import { render, staticRenderFns } from "./hotelDetail.vue?vue&type=template&id=60753e07&scoped=true&"
import script from "./hotelDetail.vue?vue&type=script&lang=js&"
export * from "./hotelDetail.vue?vue&type=script&lang=js&"
import style0 from "./hotelDetail.vue?vue&type=style&index=0&id=60753e07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60753e07",
  null
  
)

export default component.exports